module.exports = __webpack_public_path__ + "img/iconxs.f7545f7e.png";